import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import siteConfig from "../config/site.config";

export const Footer = () => {
  const handleSocialClick = (platform) => {
    toast.info(`${platform} profile link will be available soon...`, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        color: '#fff'
      }
    });
  }

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <div className="footer-logo-text">{siteConfig.siteName}</div>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
                <a onClick={() => handleSocialClick('LinkedIn')} href={siteConfig.socialLinks.linkedin}><img src={navIcon1} alt="LinkedIn" /></a>
                <a onClick={() => handleSocialClick('Facebook')} href={siteConfig.socialLinks.facebook}><img src={navIcon2} alt="Facebook" /></a>
                <a onClick={() => handleSocialClick('Instagram')} href={siteConfig.socialLinks.instagram}><img src={navIcon3} alt="Instagram" /></a>
            </div>
            <p>Copyright @{new Date().getFullYear()}. All Rights Reserved by <a href={siteConfig.author.github}>{siteConfig.author.name}</a></p>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </footer>
  )
}
